import * as React from "react"
import { Head, Link } from "@inertiajs/react"
import { Plus, Sparkles } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { DeckFormDialog } from "@/components/flashcards/DeckFormDialog"
import { DeckList } from "@/components/flashcards/DeckList"
import { Button } from "@/components/ui/button"
import type { ProgramOption } from "@/components/ProgramSelect"
import type { DeckSummary } from "@/types/flashcards"

export default function AdminDecksIndex({ decks, programs }: { decks: DeckSummary[]; programs: ProgramOption[] }) {
  const [creating, setCreating] = React.useState(false)

  return (
    <>
      <Head title="Official decks">
        <meta name="description" content="Create, edit, and publish the official flashcard decks every user can study." />
        <meta property="og:title" content="Official decks" />
        <meta property="og:description" content="Create, edit, and publish the official flashcard decks every user can study." />
      </Head>
      <AdminShell>
        <PageHeader
          title="Official decks"
          description="Decks every user can study. Drafts stay hidden until you publish them."
          actions={
            <>
              <Button type="button" variant="secondary" onClick={() => setCreating(true)}>
                <Plus className="h-4 w-4" /> New deck
              </Button>
              <Button asChild>
                <Link href="/generations/new?kind=deck&official=1">
                  <Sparkles className="h-4 w-4" /> Generate with AI
                </Link>
              </Button>
            </>
          }
        />

        <div className="mt-6">
          {decks.length === 0 ? (
            <div className="callout">
              <p>No official decks yet. Create one to start adding cards.</p>
            </div>
          ) : (
            <DeckList decks={decks} hrefFor={(deck) => `/admin/decks/${deck.id}`} showStatus />
          )}
        </div>

        <DeckFormDialog
          open={creating}
          onOpenChange={setCreating}
          action="/admin/decks"
          method="post"
          title="New official deck"
          description="It starts as a draft. Publish it when the cards are ready."
          submitLabel="Create draft"
          programs={programs}
        />
      </AdminShell>
    </>
  )
}
